<template>
  <div class="config">
    <v-row>
      <v-col cols="12" md="12">
        <div class="card card-custom card-compact sub-card">
          <div class="card-header pl-0 pr-0 card-header-nobdr">
            <div class="card-title">
              <h3 class="card-label">Payment Form Configuration</h3>
              <span class="sub-title">Please select your preferred payment mode</span>
            </div>
            <div class="header-aside-content">
              <div class="aside-btn w-200">
                <v-select
                  :items="paymentModes"
                  item-text="name"
                  item-value="paymentModeId"
                  v-model="selectedPaymentMode"
                  @change="getFormResource"
                  dense
                  label="Payment Modes"
                  outlined
                ></v-select>
              </div>
            </div>
          </div>
          <div class="card-body pr-0 pl-0">
            <v-data-table
              :headers="configHeader"
              :items="paymentConfigList"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:item.inputValue="{ item }">
              
                <v-text-field
                  label="value"
                  v-model="formValues[item.paymentFormKeyId].defaultValue"
                  :ref="'formInput' + item.paymentFormKeyId"
                ></v-text-field>
              </template>
              <template v-slot:item.editableByCustomer="{ item }">
                <div class="table-checkbox">
                  <v-checkbox
                    label=""
                    color="primary"
                    :false-value="false"
                    :true-value="true"
                    v-model="
                      formValues[item.paymentFormKeyId]
                        .shouldBeVisibleToCustomer
                    "
                    :ref="'formCheckbox' + item.paymentFormKeyId"
                    @change="visibleEdited(item)"
                    hide-details
                  ></v-checkbox>
                </div>
              </template>
              <template v-slot:item.action="{ item} ">
                 <v-icon
                      small
                      class="mr-2"
                      @click="editConfig(item)"
                    >
                      mdi-pencil
                  </v-icon>
              </template>
              <template v-slot:item.status="{ item }">
                <span class="table-btn" :class="item.status">{{
                  item.status
                }}</span>
              </template>
            </v-data-table>
          </div>
          <div class="card-body pt-2">
            <div class="btn-wrapper btn-aside-right" v-if="addConfig">
              <v-btn depressed class="custom-secondary-btn mr-3">
                Cancel
              </v-btn>
              <v-btn
                depressed
                color="primary"
                @click.prevent="submitPaymentConfig"
              >
                Submit
              </v-btn>
            </div>
            <div class="btn-wrapper btn-aside-right" v-if="showUpdate && !addConfig">
              
              <v-btn
                depressed
                color="primary"
                :loading="updateLoading"
                :disabled="updateLoading"
                @click.prevent="updateConfig"
              >
                Update
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Promise from "../../../../../lib/mixins/ExtendedPromises";
import Config from "../../../../../repositories/adminPaymentFormKeyController.js";
import AdminPayment from "../../../../../repositories/adminPaymentModeController";
import formController from "../../../../../repositories/adminMerchantPaymentFormController";
export default {
  name: "payment-form",
  mixins: [Promise],
  data() {
    return {
      merchantId: "",
      formValues: {},
      paymentModes: [],
      selectedPaymentMode: "",
      paymentConfigList: [],
      configHeader: [],
      formResource: [],
      addConfig: false,
      isEditable: true,
      currentEditedItem: {},
      showUpdate: false,
      updateLoading: false,
      currentFormResource: []
    };
  },
  created() {
    this.merchantId = this.$route.params.id;
  },
  mounted() {
    this.getPaymentModes();
    this.setTableHeader();
  },
  computed: {
    getFormValues () {
      return this.formValues;
    }
  },
  methods: {
    disableFields () {
      if(this.formResource.length > 0){
        setTimeout(() => {
          for (const [key, value] of Object.entries(this.$refs)) {           
             this.$refs[key].$el.classList.add("disabled");
          }
        }, 200)
      }
    },
    editConfig (item) {
      this.currentEditedItem = item;
      this.isEditable = true;
      this.showUpdate = true;
      let element = this.$refs['formInput'+item.paymentFormKeyId];
      let element2 =  this.$refs['formCheckbox'+item.paymentFormKeyId];
      this.$nextTick(() => {
        element.$el.classList.remove("disabled");
        element2.$el.classList.remove("disabled");
      })
      this.currentFormResource = this.formResource.filter((item) => item.paymentFormKeyId === this.currentEditedItem.paymentFormKeyId)
    },
    updateConfig () {
      this.updateLoading = true;      
      const operation = this.response(
        formController.updateMerchantPaymentFormDetail(this.currentFormResource[0].merchantPaymentFormId, this.formValues[this.currentEditedItem.paymentFormKeyId])
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
              this.$toasted.show(response.data.message);
              this.updateLoading = false;

          }
        })
        .catch(err => {
          this.updateLoading = false;
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    visibleEdited (item) {
      let element = this.$refs['formInput'+item.paymentFormKeyId];
      if(this.formValues[item.paymentFormKeyId].shouldBeVisibleToCustomer) {
        this.$nextTick(() => {
          element.$el.classList.add("disabled");
        })
      } else {
        this.$nextTick(() => {
          element.$el.classList.remove("disabled");
        })
      }
      
      
     
    },
    submitPaymentConfig() {
      let payload = [];
      for (const [key, value] of Object.entries(this.formValues)) {
        if( value.defaultValue === '' && value.shouldBeVisibleToCustomer === null) {
          this.formValues[key].defaultValue = "NA";
        }
        if( value.shouldBeVisibleToCustomer === null) {
          this.formValues[key].shouldBeVisibleToCustomer = false;
        }
        payload.push(this.formValues[key]);
      }

      const operation = this.response(
        formController.addNewMerchantPaymentFormDetail(this.merchantId,this.selectedPaymentMode, payload)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.$toasted.show(response.data.message);
            this.getFormResource();
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    setTableHeader() {
      if(this.addConfig){
        this.configHeader = [
            {
              text: "Column Name",
              align: "start",
              value: "columnName"
            },
            { text: "Mode", value: "paymentMode" },
            { text: "Input Type", value: "inputType" },
            { text: "Input value", value: "inputValue" },
            { text: "Editable By Customer", value: "editableByCustomer" },
            { text: "Status", value: "status" }
          ];
      } else {
        this.configHeader = [
            {
              text: "Column Name",
              align: "start",
              value: "columnName"
            },
            { text: "Mode", value: "paymentMode" },
            { text: "Input Type", value: "inputType" },
            { text: "Input value", value: "inputValue" },
            { text: "Editable By Customer", value: "editableByCustomer" },
            { text: "Action", value: "action" },
            { text: "Status", value: "status" }
            
          ];
      }
          
    },
    getPaymentModes() {
      const operation = this.response(AdminPayment.getAllPaymentModes());
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.paymentModes = response.data;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    getFormResource () {
        const operation = this.response(
        formController.getAllMerchantPaymentFormResource(this.merchantId,this.selectedPaymentMode)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.formResource = response.data;
            if(response.data.length === 0) {
              this.addConfig = true;
              this.isEditable = true;
            } else {
              this.addConfig = false;
              this.isEditable = false;
            }
            
            this.setTableHeader();
            this.getPaymentForm();
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    getPaymentForm() {
      this.formValues= {};
      const operation = this.response(
        Config.getAllPaymentFormKeys(this.selectedPaymentMode)
      );
      operation
        .then(response => {
          if (operation.isFulfilled()) {
            this.paymentConfigList = response.data;
            this.paymentConfigList.forEach(item => {
              this.formValues[item.paymentFormKeyId] = {
                defaultValue: "",
                shouldBeVisibleToCustomer: null,
                paymentFormKeyId: item.paymentFormKeyId
              };
            });

            this.formResource.forEach(item => {
                this.formValues[item.paymentFormKeyId].defaultValue = item.defaultValue;
                this.formValues[item.paymentFormKeyId].shouldBeVisibleToCustomer = item.editableByCustomer;

            })
            this.disableFields();
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    }
  }
};
</script>
